import React from "react";

import isIntuit from "Intuit/isIntuit";
import { Field } from "react-final-form";

import SIFormLabel from "Common/forms/SIFormLabel";
import { Col } from "Common/Grid";
import { Radio } from "Theme/RadioGroup";

export interface SIFinalFormRadioGroupProps {
  disabled?: boolean;
  inline?: boolean;
  options: Array<[string, React.ReactNode]> | Record<string, React.ReactNode>;
  name: string;
  label?: string;
  validate?: (value: any) => string | null | undefined;
  guidance?: string;
}

export const SIFinalFormRadioGroupNoCol = ({ disabled = false, inline = false, options, name, label, validate, guidance }: SIFinalFormRadioGroupProps) => {
  const mappedOptions = Array.isArray(options) ? options : Object.entries(options);
  return (
    <>
      {label && <SIFormLabel label={label} guidance={guidance} />}
      {mappedOptions.map(
        (
          [value, optionLabel], // For radios in final form: Use multiple field elements, identical name, no wrapper
        ) => (
          // The underlying components themselves use id/fors to associate the label with the input
          // https://final-form.org/docs/react-final-form/examples/simple
          <Field name={name} type="radio" value={value} validate={validate} key={value}>
            {({ input }) => (
              <Radio
                name={input.name}
                onChange={input.onChange}
                value={input.value}
                checked={input.checked}
                disabled={disabled || input.disabled}
                inline={inline}
              >
                {optionLabel}
              </Radio>
            )}
          </Field>
        ),
      )}
    </>
  );
};

const SIFinalFormRadioGroup = ({ disabled = false, inline, options, name, label, validate, mb, ...rest }) => {
  const marginBottom = mb || (isIntuit() ? 3 : 4);
  return (
    <Col mb={marginBottom} {...rest}>
      <SIFinalFormRadioGroupNoCol disabled={disabled} inline={inline} options={options} name={name} label={label} validate={validate} />
    </Col>
  );
};

export default SIFinalFormRadioGroup;
